import { useEffect, useMemo, useState } from "react";
import { Button, Modal, Typography } from "antd";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getOrderMonthlyLimitStatus } from "../../Utilis/CompanySetting/orderMonthlyLimit";
import "./style.scss";

/**
 * Global notice when GET /company reports order_monthly_limit_status.reached.
 * Flag lives in Redux company until the next company refetch.
 * Dismissible per page; re-opens on navigation while still reached (and after login).
 */
export const OrderMonthlyLimitReachedModal = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { userInfo, company } = useSelector(
    (state: any) => state.setReducer || {}
  );

  const [dismissed, setDismissed] = useState(false);

  const status = useMemo(
    () => getOrderMonthlyLimitStatus(company),
    [company]
  );

  const isReached = status?.reached === true;

  // Re-show on every route after login while the company is still at the cap.
  useEffect(() => {
    setDismissed(false);
  }, [pathname]);

  // Clear dismiss when the backend reports the cap is no longer reached.
  useEffect(() => {
    if (!isReached) {
      setDismissed(false);
    }
  }, [isReached]);

  const open = !!userInfo && !!company && isReached && !dismissed;

  return (
    <Modal
      className="order-monthly-limit-reached-modal"
      open={open}
      centered
      width={560}
      footer={null}
      onCancel={() => setDismissed(true)}
      destroyOnClose
      maskClosable
    >
      <div className="order-monthly-limit-reached-modal__content">
        <Typography.Title
          level={4}
          className="order-monthly-limit-reached-modal__title"
        >
          {t("companySettings.orderMonthlyLimitReached.title")}
        </Typography.Title>

        <Typography.Paragraph className="order-monthly-limit-reached-modal__message">
          {t("companySettings.orderMonthlyLimitReached.message")}
        </Typography.Paragraph>

        <div className="order-monthly-limit-reached-modal__actions">
          <Button
            type="primary"
            className="order-monthly-limit-reached-modal__cta"
            onClick={() => setDismissed(true)}
          >
            {t("companySettings.orderMonthlyLimitReached.cta")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default OrderMonthlyLimitReachedModal;
